import React, { Component } from "react";
import styled from 'styled-components';
import Image from 'react-bootstrap/Image'
import spinner from './../content/img/spinner.gif';

const ContentStyles = styled.div`
.Loading {
    margin-top: 0;
    text-align: center;
    padding: 100px 0;
    z-index: 99999999;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
}
`;

class LoadingComponent extends Component {
  render() {
    return (
        <>
            <ContentStyles>
                <div className="Loading">
                    <div className="fa-3x mb-3">
                        <Image src={spinner} className="img-fluid" alt="Yükleniyor" width="80" />
                    </div>
                </div>
            </ContentStyles>
        </>
    );
  }
}
 
export default LoadingComponent;